export const AppConfig = {
    consumerId: 'e-store-eu',
    userAgent: 'e-store-eu headless',
};
